import './polyfills'
import React from 'react'
import ReactDOM from 'react-dom'
import { Provider } from 'react-redux'
import { createStore, applyMiddleware } from 'redux'
import thunk from 'redux-thunk'
import reducers from './reducers/reducers'
import { initParams } from './reducers/params'
import { initData } from './reducers/data'
import App from './components/App/App'
import './index.css'

// the id of the div to render too
//let appId = 'earningsapp'

let divId = 'earningsapp'
let windowEnv = 'earningsParams'

let wtRegion = 'US'
let divisionId = '1'
let isoCode = 'en-US'
let isFP = 0
let ticker = ''

if (window.earningsParams) {
  const params = window.earningsParams
  if (params.divisionId) divisionId = Number(params.divisionId).toString()
  if (params.wtRegion) wtRegion = params.wtRegion
  if (params.isoCode) isoCode = params.isoCode
  if (params.isFP) isFP = Number(params.isFP).toString()
  if (params.ticker) ticker = params.ticker
}

function getSyncScriptParams() {
  const scripts = document.getElementsByTagName('script')
  const lastScript = scripts[scripts.length - 1]
  const scriptName = lastScript
  windowEnv = scriptName.getAttribute('windowEnv') ? scriptName.getAttribute('windowEnv') : 'earningsParams'
  divId = scriptName.getAttribute('divId') ? scriptName.getAttribute('divId') : 'earningsapp'
}
getSyncScriptParams()

if (window[windowEnv]) {
  if (window[windowEnv].wtRegion) {
    wtRegion = window[windowEnv].wtRegion
  }
  if (window[windowEnv].divisionId) {
    divisionId = window[windowEnv].divisionId
  }

  if (window[windowEnv].isoCode) {
    isoCode = window[windowEnv].isoCode
  }

  if (window[windowEnv].isFP) {
    isFP = window[windowEnv].isFP
  }
  if (window[windowEnv].ticker) {
    ticker = window[windowEnv].ticker
  }
}

initParams.divisionId = divisionId
initParams.wtRegion = wtRegion
initParams.ticker = ticker
initParams.isoCode = isoCode

ReactDOM.render(
  <Provider store={createStore(reducers, { params: initParams, data: initData }, applyMiddleware(thunk))}>
    <App />
  </Provider>,
  document.getElementById(divId)
)



// WEBPACK FOOTER //
// ./src/index.js